import Column from '@components/column'
import {
  StyleContentWrapper,
  StyleHeaderaWrapper,
  StyleWeekWrapper,
  StyleWeekDay,
  StyleAddCircle,
  StyleUploadWrapper,
  StyleUploadItem,
} from './style'
import Row from '@components/row'
import Svg from '@components/svg'
import Button from '@components/button'
import ChooseCategories from '@commons/popups/categories'
import CardHeading from '@commons/headings/card'
import Image from '@components/image'
import Typography from '@components/typography'
import Fields from '@components/fields'
import { User } from '@apis'
import { useSelector } from 'react-redux'
import { useEffect } from 'react'
import { format } from 'date-fns'
import { Helper, Constant } from '@utils'
import { useState, Fragment } from 'react'
import Circle from '@components/circle'
const AppointmentForm = ({ setFieldValue, values, loading }) => {
  const date = new Date()
  const currentDate = format(new Date(date), 'yyyy-MM-dd')
  const [dates, setDates] = useState([])
  const [visible, setVisible] = useState<boolean>(false)
  const { items: doctors } = useSelector((state: any) => state.suggestedDoctors)
  const { data: user } = useSelector((state: any) => state.user)

  const fetchDoctors = async () => {
    await User.list({
      params: {
        page: 1,
        limit: 12,
        role: 'doctor',
        parentId: user?.id,
      },
      state: 'suggestedDoctors',
    })
  }

  const handleChangeDate = (event: any) => {
    const date = (event.target as HTMLElement)
      .closest('[data-cross-date]')
      ?.getAttribute('data-cross-date')

    if (!!date) {
      setFieldValue('date', date)
    }
  }

  const handleRemoveReport = (event: any) => {
    const index: any = (event.target as HTMLElement)
      .closest('[data-cross-index]')
      ?.getAttribute('data-cross-index')
    if (index >= 0) {
      const reports = values?.reports?.filter((_, i: number) => index != i)
      setFieldValue('reports', reports)
    }
  }

  useEffect(() => {
    if (!doctors?.length) {
      fetchDoctors()
    }
    setDates(Helper.getNext7Dates(currentDate))
  }, [])
  return (
    <Column bg={'white'} styleColumn="border-radius:12px;">
      <StyleHeaderaWrapper>
        <CardHeading title="Schedule Doctors" />
      </StyleHeaderaWrapper>
      <StyleContentWrapper>
        <Column rowGap={20}>
          <Fields.ChooseButton
            multiple={false}
            name="userId"
            label="Suggested Doctors"
            styleButton="
          height:auto;
          border:0px;
        "
            items={
              !!doctors?.length
                ? doctors?.map((doctor) => {
                    return {
                      id: doctor?.id,
                      name: doctor?.name,
                      render: () => {
                        return (
                          <Column
                            rowGap={10}
                            styleColumn="padding:5px 0px;"
                            alignItems="center"
                            justifyContent="center"
                          >
                            <Image
                              src={`${process.env.BUCKET_URL}/${doctor?.avatar}`}
                              height={50}
                              width={50}
                              styleImage="border-radius:50%;"
                              fallbackType="doctor"
                            />
                            <Typography
                              content={doctor?.name}
                              size={14}
                              styleText="text-align:center"
                            />
                          </Column>
                        )
                      },
                    }
                  })
                : []
            }
            titleAsKey="name"
            valueAsKey="id"
          />
          <Fields.ChooseButton
            multiple={false}
            name="infos.appointmentType"
            items={[
              {
                name: 'Schedule',
              },
              {
                name: 'Instant',
              },
              {
                name: 'At Clinic',
              },
            ]}
            titleAsKey="name"
            valueAsKey="name"
            label="Appointment Type"
          />
          <Column rowGap={10}>
            <Typography
              content="Availability"
              weight={400}
              size={14}
              variant="label"
              tc={'text'}
            />
            <StyleWeekWrapper onClick={handleChangeDate}>
              {dates?.map((date: any) => {
                const isActive = values.date == date
                return (
                  <Fragment key={date}>
                    <StyleWeekDay isActive={isActive} data-cross-date={date}>
                      <Typography
                        content={format(date, 'eee')}
                        size={14}
                        tc={!!isActive ? 'white' : 'text'}
                      />
                      {format(date, 'dd')}
                    </StyleWeekDay>
                  </Fragment>
                )
              })}
            </StyleWeekWrapper>
          </Column>
          <Fields.ChooseButton
            label="Pick ayou Preferred Time Slot:"
            items={[
              {
                name: 'Morning',
              },
              {
                name: 'Afternoon',
              },
              {
                name: 'Evening',
              },
            ]}
            name="infos.shift"
            titleAsKey="name"
            valueAsKey="name"
            multiple={false}
          />
          <Fields.ChooseButton
            items={Constant.slots[values?.infos?.shift?.toLowerCase()].map(
              (item: any) => {
                return {
                  label: `${item?.startTime}-${item?.endTime}`,
                  value: `${item?.startTime}-${item?.endTime}`,
                }
              },
            )}
            name="time"
            titleAsKey="label"
            valueAsKey="value"
            multiple={false}
          />
          <Column rowGap={15}>
            <Typography content="Symptoms:" size={14} weight={500} />
            <ChooseCategories
              selectedItems={values?.symptoms}
              visible={visible}
              setVisible={setVisible}
              selector="symptoms"
              type="Symptom"
              title="Symptom"
              onClick={(item: any) => {
                const findIndex = values?.symptoms?.findIndex(
                  (selected: any) => selected?.id == item.id,
                )
                if (findIndex >= 0) {
                  setFieldValue(
                    'symptoms',
                    values?.symptoms?.filter(
                      (symptom) => symptom?.id != item?.id,
                    ),
                  )
                } else {
                  setFieldValue('symptoms', [...(values?.symptoms || []), item])
                }
              }}
            />
            <Row styleRow="flex-flow:row wrap;" rowGap={10} colGap={15}>
              <Column alignItems="center" rowGap={5}>
                <StyleAddCircle onClick={() => setVisible(true)}>
                  <Svg svg="plus" />
                </StyleAddCircle>
                <Typography content="Add" size={12} />
              </Column>
              {values?.symptoms?.map((symptom: any) => {
                return (
                  <Fragment key={symptom?.id}>
                    <Column rowGap={5}>
                      <Image
                        width={50}
                        height={50}
                        styleImage={`border-radius:50%;`}
                        src={`${process.env.BUCKET_URL}/${symptom?.infos?.image}`}
                      />
                      <Typography
                        content={symptom?.name}
                        size={12}
                        styleText="text-align:center"
                      />
                    </Column>
                  </Fragment>
                )
              })}
            </Row>
          </Column>
          <Column rowGap={15}>
            <Typography content="Send us Your Report:" size={14} weight={500} />
            <StyleUploadWrapper onClick={handleRemoveReport}>
              <Fields.Upload
                name="report"
                varient="drag"
                styleWrapper="width:100px;height:80px;"
                size={70}
                onChange={(file) => {
                  setFieldValue(
                    'reports',
                    !!values?.reports?.length
                      ? [...values?.reports, file]
                      : [file],
                  )
                }}
              />
              {values?.reports?.map((report: any, index: number) => {
                return (
                  <StyleUploadItem>
                    {report?.extension == 'pdf' ? (
                      <></>
                    ) : (
                      <Image src={`${report?.info},${report?.base64}`} />
                    )}
                    <Circle
                      bg={'danger'}
                      size={20}
                      styleCircle="position:absolute;top:0px;right:0px;"
                      data-cross-index={index}
                    >
                      <Svg svg="cross" color={'white'} size={14} />
                    </Circle>
                  </StyleUploadItem>
                )
              })}
            </StyleUploadWrapper>
          </Column>
          <Fields.TextArea
            name="infos.shareAnything"
            label="Anything you want to share"
            placeholder="Anything you want to share"
          />
          <Row
            justifyContent="space-between"
            styleRow="position:sticky;bottom:0px;padding:10px 0px;background:white;"
          >
            <Button
              outline
              type="button"
              title="Cancel"
              styleButtonWrapper="width:49%"
              styleButton="width:100%;"
            />
            <Button
              type="submit"
              title="Submit"
              styleButtonWrapper="width:49%"
              styleButton="width:100%;"
              loading={loading}
            />
          </Row>
        </Column>
      </StyleContentWrapper>
    </Column>
  )
}

export default AppointmentForm
